import { render, staticRenderFns } from "./myQRcode.vue?vue&type=template&id=3b570e38&scoped=true&"
import script from "./myQRcode.vue?vue&type=script&lang=js&"
export * from "./myQRcode.vue?vue&type=script&lang=js&"
import style0 from "./myQRcode.vue?vue&type=style&index=0&id=3b570e38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b570e38",
  null
  
)

export default component.exports